import { Calendar } from 'fullcalendar';
import rrulePlugin from '@fullcalendar/rrule';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// 1. Define Breakpoints (Fixes the ReferenceError)
const breakpoints = {
    md: 768,
};

async function renderCalendar() {
    const calendarEl = document.getElementById('parish-calendar');

    // 2. Safety Checks
    // Ensure element exists and isn't already initialized
    if (!calendarEl || calendarEl.classList.contains('fc')) return;

    console.log('Initializing Calendar...');

    const isMobile = window.innerWidth < breakpoints.md;

    const calendar = new Calendar(calendarEl, {
        // Since you imported rrulePlugin, pass it directly here
        plugins: [rrulePlugin],
        initialView: isMobile ? 'listMonth' : 'dayGridMonth',
        
        // Responsive Ratios
        aspectRatio: isMobile ? 0.8 : 1.35,
        handleWindowResize: true,
        height: 'auto',      // Allows row height to increase dynamically
        dayMaxEvents: false, // Show all events, no "+more" link

        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: isMobile ? 'listMonth' : 'dayGridMonth,timeGridWeek,listMonth'
        },

        eventSources: [
            {
                // Source A: From PHP ThemeData
                url: typeof ThemeData !== 'undefined' ? ThemeData.eventsUrl : '',
                method: 'GET',
                color: '#2c3e50', // Navy for primary events
                failure: () => console.error("Source A failed")
            },
            {
                // Source B: From PHP ThemeData_B
                url: typeof ThemeData_B !== 'undefined' ? ThemeData_B.eventsUrl : '',
                method: 'GET',
                color: '#e67e22', // Orange for special events
                failure: () => console.error("Source B failed")
            }
        ],

        eventDidMount: function (info) {
            const description = info.event.extendedProps.description;

            if (description) {
                // 3. Tooltip Logic (Tippy)
                tippy(info.el, {
                    content: description,
                    placement: 'top',
                    theme: 'light-border',
                    animation: 'shift-away',
                    allowHTML: true,
                    appendTo: document.body, // Fixed positioning on mobile
                    maxWidth: isMobile ? 250 : 350,
                    trigger: isMobile ? 'click' : 'mouseenter',
                    interactive: true,
                });

                // 4. List View Description Injection
                if (info.view.type.includes('list')) {
                    const titleEl = info.el.querySelector('.fc-list-event-title');
                    if (titleEl && !titleEl.querySelector('.fc-event-description')) {
                        let descEl = document.createElement('div');
                        descEl.className = 'fc-event-description';
                        descEl.style.fontSize = '0.85em';
                        descEl.style.marginTop = '4px';
                        descEl.innerHTML = `<i>${description}</i>`;
                        titleEl.appendChild(descEl);
                    }
                }
            }
        }
    });

    calendar.render();
}

// 5. Execution Logic
function initCalendarView() {
    renderCalendar();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalendarView);
} else {
    initCalendarView();
}

// 6. MutationObserver (Optimized)
const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        if (mutation.addedNodes.length && document.getElementById('parish-calendar')) {
            initCalendarView();
            break;
        }
    }
});

observer.observe(document.body, { childList: true, subtree: true });